// FIX: Replaced placeholder content with a functional ReportPostModal component.
import React, { useState } from 'react';

interface ReportPostModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (reason: string, details: string) => void;
    triggerRect?: DOMRect | null;
    title?: string;
}

const ReportPostModal: React.FC<ReportPostModalProps> = ({ isOpen, onClose, onSubmit, title = "Report Post" }) => {
    const [reason, setReason] = useState('');
    const [details, setDetails] = useState('');

    if (!isOpen) return null;

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (reason) {
            onSubmit(reason, details);
            onClose(); // Close after submit
        }
    };

    return (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={onClose}>
            <div className="bg-[var(--primary-dark-purple)] border border-white/20 p-6 rounded-2xl shadow-2xl w-full max-w-sm text-white" onClick={e => e.stopPropagation()}>
                <h2 className="text-2xl font-bold mb-4 aurora-text">{title}</h2>
                <form onSubmit={handleSubmit}>
                    <div className="space-y-4">
                        <select value={reason} onChange={e => setReason(e.target.value)} className="w-full bg-black/30 border border-white/20 rounded-xl p-3 text-white focus:ring-[var(--accent-pink)] focus:border-[var(--accent-pink)]" required>
                            <option value="" className="text-gray-800">Select a reason</option>
                            <option value="spam" className="text-gray-800">It's spam</option>
                            <option value="hate-speech" className="text-gray-800">Hate speech or symbols</option>
                            <option value="inappropriate" className="text-gray-800">Inappropriate Content</option>
                            <option value="spoiler" className="text-gray-800">Contains a spoiler</option>
                            <option value="other" className="text-gray-800">Other</option>
                        </select>
                        <textarea
                            value={details}
                            onChange={e => setDetails(e.target.value)}
                            placeholder="Provide additional details (optional)"
                            rows={3}
                            className="w-full bg-black/30 border border-white/20 rounded-xl p-3 text-white placeholder-gray-400 focus:ring-[var(--accent-pink)] focus:border-[var(--accent-pink)]"
                        />
                    </div>
                    <div className="flex justify-end space-x-3 mt-6">
                        <button type="button" onClick={onClose} className="bg-white/10 text-white font-bold py-2 px-4 rounded-xl hover:bg-white/20 transition-colors">Cancel</button>
                        <button type="submit" disabled={!reason} className="bg-[var(--accent-pink)] text-white font-bold py-2 px-4 rounded-xl disabled:opacity-50 disabled:cursor-not-allowed hover:opacity-90 transition-opacity">Submit Report</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ReportPostModal;